/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { SellerDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class SellerService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 셀러 목록을 조회합니다.
   *
   * @tags SellerService
   * @name GetSellers
   * @summary Get Seller List
   * @request GET:/v1/sellers
   * @secure
   */
  getSellers = (
    query?: {
      isUnMatch?: boolean;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SellerDto[], any>({
      path: `/v1/sellers`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SellerService
   * @name GetSeller
   * @summary Get Seller by ID
   * @request GET:/v1/sellers/{sellerId}
   * @secure
   */
  getSeller = (
    sellerId: number,
    query?: {
      isUnMatch?: boolean;
      searchKeyword?: string;
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SellerDto, any>({
      path: `/v1/sellers/${sellerId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
